module.exports = __webpack_public_path__ + "static/media/banner_homework_report_detail.886c6c4b.png";